import { UPDATE_ANALYTICS } from '../constants/actionTypes'

export default (state = {}, action) => {
    switch (action.type) {
        case UPDATE_ANALYTICS:
            return action.payload
        default:
            return state
    }
}
